import type { Market } from '../../entities/Market';

export const GLOBAL = 'ZZ';

export function isGlobalMarket(retailUnit: Market['retailUnit']) {
  return retailUnit === GLOBAL;
}

export function marketComparer(a: Market, b: Market) {
  const first = a.countryName || a.retailUnit;
  const second = b.countryName || b.retailUnit;

  if (a.retailUnit === GLOBAL) {
    return -1;
  }

  if (b.retailUnit === GLOBAL) {
    return 1;
  }

  if (first < second) {
    return -1;
  }

  if (first > second) {
    return 1;
  }

  return 0;
}
